module.exports = __webpack_public_path__ + "static/media/wangzheng.692ec12d.png";